import React, { useState } from 'react';
import { Spinner, Alert } from '../../services/notiflix.service';
import BlockchainService from '../../services/blockchain.service';
import AccountSettingsService from '../../services/account-settings.service';
import { connect, disconnect } from '../../actions/wallet';
import { useDispatch } from 'react-redux';
import { CloseButtonSvgIcon } from './IconProvider';
import { useTranslation } from 'react-i18next';
import configService from '../../services/config.service';
const PlatformWalletConnection = ({ setIsWalletExist, paymentRequest }) => {
  const [isConnectWallet, setConnectWallet] = useState(null);
  const dispatch = useDispatch();
  const { t } = useTranslation(['platformWalletConnection', 'common']);
  const connectWallet = async () => {
    try {
      if (isConnectWallet != null) {
        return false;
      }

      Spinner.show();
      let walletResp = await BlockchainService.connectWallet();

      if (walletResp.status === 'failure') {
        Spinner.hide();
        Alert.error(walletResp.message);
        return false;
      }

      Spinner.hide();
      let formData = {
        walletAddress: walletResp.data.walletAddress,
      };
      setConnectWallet(walletResp.data.walletAddress);

      dispatch(connect(formData));
      const wallets = {
        wallet_address: walletResp.data.walletAddress,
        is_whitelisted: 0,
      };

      let res = await AccountSettingsService.addUserWallets(wallets);

      if (res.status === 'failure') {
        Spinner.hide();
        Alert.error(res.message);
        dispatch(disconnect());
        setConnectWallet(null);
        return false;
      }

      Spinner.hide();
      setIsWalletExist(false);
      paymentRequest(false, false, null, true);
    } catch (error) {
      Spinner.hide();
      Alert.error(error.message);
      return false;
    }
  };

  return (
    <>
      <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
        <div className="relative w-auto mx-3 my-4 max-w-3xl ">
          {/*content*/}
          <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full dark:bg-slate-800  dark:text-slate-200  bg-white outline-none focus:outline-none md:w-[512px] md:min-w-[512px] ">
            {/*header*/}
            <button
              className="p-1 ml-auto bg-transparent border-0 text-black text-3xl leading-none font-semibold outline-none focus:outline-none absolute right-1 top-3 z-10 flex justify-center items-center"
              onClick={() => setIsWalletExist(false)}
            >
              <span className="bg-transparent text-black w-10 dark:bg-slate-400 dark:rounded-md block outline-none focus:outline-none">
                <CloseButtonSvgIcon />
              </span>
            </button>
            {/*body*/}

            <div className="p-10">
              <div>
                <h3 className="text-3xl font-medium mb-4">
                  {t('choose_destination')}
                </h3>
                <p className="mb-3">
                  {t('complete_transaction_instruction', {
                    appName: configService.appName(),
                  })}
                </p>
                <div className="py-6 px-6 text-center flex flex-col gap-2 justify-between">
                  <button
                    onClick={() => connectWallet()}
                    className="bg-GreenColor active:bg-[#92C24B] w-full text-brandBlue border border-GreenColor font-bold uppercase text-sm px-6 py-3 rounded-lg  inline-block shadow hover:shadow-lg outline-none focus:outline-none  mb-1 ease-linear transition-all duration-150"
                    type="button"
                  >
                    {t('common:connect_wallet')}
                  </button>
                  <button
                    className="bg-white active:bg-[#92C24B] text-brandBlue border border-gray-300 font-bold uppercase text-sm px-6 py-3 rounded-lg w-auto inline-block shadow hover:shadow-lg outline-none focus:outline-none  mb-1 ease-linear transition-all duration-150"
                    type="button"
                    onClick={() => {
                      paymentRequest();
                      setIsWalletExist(false);
                    }}
                  >
                    Platform wallet
                  </button>
                </div>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default PlatformWalletConnection;
